// Mock data for Almaguin Highlands Chamber of Commerce clone (frontend-only)

export const IMAGES = {
  // Authentic Ontario cottage country / Almaguin Highlands imagery
  heroA: 'https://images.unsplash.com/photo-1533061968564-f84e14bb5501?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000',
  heroB: 'https://images.unsplash.com/photo-1617803676663-3aa36f6d148c?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000',
  heroC: 'https://images.unsplash.com/photo-1541363706841-989e82817186?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000',
  joinImg: 'https://images.unsplash.com/photo-1596329543776-b725a410dc38?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
  atv: 'https://images.unsplash.com/photo-1607388510015-c632e99da586?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400',
  cafe: 'https://images.unsplash.com/photo-1617803735768-d2ac6e2812ea?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400',
  gym: 'https://images.unsplash.com/photo-1496060169243-453fde45943b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400',
};

export const HERO_SLIDES = [IMAGES.heroA, IMAGES.heroB, IMAGES.heroC];

// Category-relevant business photos used as a fallback when a member has no real image.
const CAT_IMG = {
  campground: 'https://images.unsplash.com/photo-1682868796363-d2fb6a50dd3a?crop=entropy&cs=srgb&fm=jpg&q=80&w=800',
  cabin: 'https://images.unsplash.com/photo-1470748085385-5fbb3018c796?crop=entropy&cs=srgb&fm=jpg&q=80&w=800',
  marine: 'https://images.unsplash.com/photo-1534430476764-c1e0b96e1f0d?crop=entropy&cs=srgb&fm=jpg&q=80&w=800',
  auto: 'https://images.unsplash.com/photo-1570129476815-ba368ac77013?crop=entropy&cs=srgb&fm=jpg&q=80&w=800',
  pet: 'https://images.unsplash.com/photo-1516453734593-8d198ae84bcf?crop=entropy&cs=srgb&fm=jpg&q=80&w=800',
  medical: 'https://images.unsplash.com/photo-1629909613654-28e377c37b09?crop=entropy&cs=srgb&fm=jpg&q=80&w=800',
  fitness: 'https://images.unsplash.com/photo-1534438327276-14e5300c3a48?crop=entropy&cs=srgb&fm=jpg&q=80&w=800',
  agriculture: 'https://images.unsplash.com/photo-1615811361523-6bd03d7748e7?crop=entropy&cs=srgb&fm=jpg&q=80&w=800',
  education: 'https://images.unsplash.com/photo-1509062522246-3755977927d7?crop=entropy&cs=srgb&fm=jpg&q=80&w=800',
  restaurant: 'https://images.unsplash.com/photo-1613274554329-70f997f5789f?crop=entropy&cs=srgb&fm=jpg&q=80&w=800',
  construction: 'https://images.unsplash.com/photo-1694521787162-5373b598945c?crop=entropy&cs=srgb&fm=jpg&q=80&w=800',
  realestate: 'https://images.unsplash.com/photo-1628652462669-6835a3090864?crop=entropy&cs=srgb&fm=jpg&q=80&w=800',
  arts: 'https://images.unsplash.com/photo-1472653431158-6364773b2a56?crop=entropy&cs=srgb&fm=jpg&q=80&w=800',
  community: 'https://images.unsplash.com/photo-1599059813005-11265ba4b4ce?crop=entropy&cs=srgb&fm=jpg&q=80&w=800',
  government: 'https://images.unsplash.com/photo-1617139938955-92641dd1e6b3?crop=entropy&cs=srgb&fm=jpg&q=80&w=800',
  storefront: 'https://images.unsplash.com/photo-1770051669143-9e11b102a0f2?crop=entropy&cs=srgb&fm=jpg&q=80&w=800',
  office: 'https://images.unsplash.com/photo-1542744173-8e7e53415bb0?crop=entropy&cs=srgb&fm=jpg&q=80&w=800',
};

// Ordered keyword rules (most specific first).
const CAT_RULES = [
  [['camp'], 'campground'],
  [['accommodation', 'resort', 'lodge', 'inn', 'cabin', 'cottage'], 'cabin'],
  [['marine', 'boat', 'dock', 'engine', 'power sport'], 'marine'],
  [['automotive', 'autromotive', 'auto '], 'auto'],
  [['pet'], 'pet'],
  [['medical', 'health', 'dental', 'denture', 'personal care'], 'medical'],
  [['fitness', 'sport', 'recreation', 'gym'], 'fitness'],
  [['agricultur', 'industry', 'farm', 'maple', 'nursery', 'tree', 'quarry'], 'agriculture'],
  [['education', 'employment', 'learning', 'library', 'leadership', 'school'], 'education'],
  [['food', 'beverage', 'restaurant', 'bakery', 'pizza', 'catering', 'freshmart', 'foodland', 'vending', 'distillery', 'cannabis'], 'restaurant'],
  [['construction', 'contractor', 'trade', 'electric', 'carpentry', 'insulation', 'window', 'heating'], 'construction'],
  [['real estate', 'realty', 'mortgage', 'insurance', 'financial', 'investor'], 'realestate'],
  [['art', 'entertainment', 'event', 'museum', 'gallery', 'printing', 'comedy', 'screen'], 'arts'],
  [['non profit', 'community', 'legion', 'historical', 'futures', 'economic', 'development'], 'community'],
  [['government', 'township', 'municipal', 'village', 'ministry', 'council', 'town office', 'chamber'], 'government'],
  [['retail', 'store', 'shop', 'hardware', 'general', 'market', 'supply'], 'storefront'],
  [['professional', 'services', 'consulting'], 'office'],
];

export function memberImage(m) {
  if (m && m.image) return m.image;
  const hay = [(m && m.name) || '', ...(((m && m.categories) || []))].join(' ').toLowerCase();
  for (const [keys, bucket] of CAT_RULES) {
    if (keys.some((k) => hay.includes(k))) return CAT_IMG[bucket];
  }
  return CAT_IMG.storefront;
}

export const NAV = [
  { label: 'HOME', href: '/' },
  {
    label: 'THE CHAMBER',
    href: '/about',
    children: [
      { label: 'About the Chamber', href: '/about' },
      { label: 'Board of Directors', href: '/about' },
      { label: 'Contact Us', href: '/contact' },
    ],
  },
  {
    label: 'MEMBERSHIP',
    href: '/membership',
    children: [
      { label: 'Benefits of Membership', href: '/benefits' },
      { label: 'Join the Chamber', href: '/membership' },
      { label: 'Member Login', href: '/membership' },
    ],
  },
  { label: 'DIRECTORY', href: '/directory' },
  {
    label: 'NEWS & EVENTS',
    href: '/news',
    children: [
      { label: 'Upcoming Events', href: '/events' },
      { label: 'Chamber News', href: '/news' },
    ],
  },
  { label: 'CONTACT', href: '/contact' },
];

export const EXPLORE_SECTIONS = [
  {
    id: 1,
    tag: '01 \u2014 CHAMBER MEMBERSHIP',
    titleAccent: 'join',
    titleRest: 'the chamber',
    body: 'Explore the possibilities by taking advantage of the benefits of a Chamber Membership and building effective business relationships. Join today and let your voice be heard.',
    note: 'Do you own a local business? Join Today.',
    image: IMAGES.joinImg,
    buttons: [
      { label: 'THE BENEFITS', style: 'solid', href: '/benefits' },
      { label: 'JOIN TODAY', style: 'outline', href: '/membership' },
    ],
    imageSide: 'right',
  },
  {
    id: 2,
    tag: '02 \u2014 FIND A BUSINESS',
    titleAccent: 'business',
    titleRest: 'directory',
    body: "Search our local business directory to discover Almaguin's finest businesses in the region.",
    note: 'To get listed, please explore Chamber Membership.',
    image: IMAGES.cafe,
    buttons: [{ label: 'SEARCH BUSINESSES', style: 'solid', href: '/directory' }],
    imageSide: 'left',
  },
];

export const FEATURED_MEMBERS = [
  { id: 1, name: 'Outdoor Adventures ATV', category: 'Recreation & Tours', image: IMAGES.atv },
  { id: 2, name: "Zak's", category: 'Retail & Apparel', image: IMAGES.cafe },
  { id: 3, name: 'PL Fitness & Get Glutes', category: 'Health & Wellness', image: IMAGES.gym },
  { id: 4, name: 'Winter Smile Dental', category: 'Healthcare', image: IMAGES.joinImg },
  { id: 5, name: "Yorgi's Pet Supply", category: 'Retail', image: IMAGES.heroC },
];

export const NEWS = [
  {
    id: 1,
    date: 'Sep 24, 2024',
    tag: 'EVENT',
    title: "Yuk Yuk's Pasta Dinner & Comedy Show",
    excerpt: "Yuk Yuk's Pasta Dinner and Show in Burk's Falls, Sunday Oct. 5th. Click through for tickets and all the delicious details.",
    image: IMAGES.cafe,
  },
  {
    id: 2,
    date: 'Sep 12, 2024',
    tag: 'NEW MEMBER',
    title: 'Welcome Winter Smile Dental',
    excerpt: 'Welcome to the Almaguin Highlands Chamber of Commerce! Our newest member feature \u2014 Winter Smile Dental is now open and serving the region.',
    image: IMAGES.joinImg,
  },
  {
    id: 3,
    date: 'Aug 30, 2024',
    tag: 'NEW MEMBER',
    title: "Yorgi's Pet Supply Opens in Sundridge",
    excerpt: "Welcome to Yorgi's Pet Supply! Open now in Sundridge and a new member to the Almaguin Highlands community.",
    image: IMAGES.heroC,
  },
];
